__turbopack_context__.v({
  "footer": "PlasmicFooter-module__yAvqUq__footer",
  "freeBox___90Qlo": "PlasmicFooter-module__yAvqUq__freeBox___90Qlo",
  "freeBox__qMgI": "PlasmicFooter-module__yAvqUq__freeBox__qMgI",
  "freeBox__xz6Ji": "PlasmicFooter-module__yAvqUq__freeBox__xz6Ji",
  "img": "PlasmicFooter-module__yAvqUq__img",
  "link___3RJle": "PlasmicFooter-module__yAvqUq__link___3RJle",
  "link___4EMb": "PlasmicFooter-module__yAvqUq__link___4EMb",
  "link__erP1T": "PlasmicFooter-module__yAvqUq__link__erP1T",
  "link__wKhet": "PlasmicFooter-module__yAvqUq__link__wKhet",
  "text__hm4Hp": "PlasmicFooter-module__yAvqUq__text__hm4Hp",
  "text__nKthk": "PlasmicFooter-module__yAvqUq__text__nKthk",
  "text__uQpcv": "PlasmicFooter-module__yAvqUq__text__uQpcv",
  "text__uqDsE": "PlasmicFooter-module__yAvqUq__text__uqDsE",
});
